<template>
  <div>
    <Row class="search-con">
      <Col span="24">

        <Input clearable placeholder="输入关键字搜索" class="search-input" v-model="keyword" />

        <label class="search-label">平台</label>
        <Select v-model="live_id" class="search-input" clearable filterable>
          <Option v-for="item in liveIds" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>

        <label class="search-label">账号</label>
        <Select v-model="user_id" class="search-input" clearable filterable>
          <Option v-for="item in userIds" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>

        <Button @click="handleButtonSearch" class="search-btn" type="primary">搜索</Button>

        <Button @click="showAddUser" type="primary" style="margin-left: 20px;">添加</Button>

      </Col>
    </Row>
    <Card>
      <tables
        editable
        :columns="columns"
        v-model="tableData"
        :loading="tableLoading"
      />
      <Row class="page-con">
        <div class="page-bottom">
          <Page
            :current="page"
            :total="total"
            :page-size="pageSize"
            show-sizer
            show-elevator
            @on-change="changePage"
            @on-page-size-change="changePageSize"
          />
        </div>
      </Row>
    </Card>

    <Modal
      :width="700"
      :mask-closable="false"
      v-model="showAddStandUserModal"
      title="添加对标账号"
      footer-hide
      >
      <Forms_stand_user :resetFlag="resetFlag"
        ref="addStandUser"  
       @on-ok="addStandUserEmit" @on-cancel="cancel" />
    </Modal>

    <Modal
      :width="700"
      :mask-closable="false"
      v-model="showEditStandUserModal"
      title="编辑对标账号"
      footer-hide
      >
      <Forms_stand_user :resetFlag="resetFlag"
        ref="editStandUser"  
       @on-ok="editStandUserEmit" @on-cancel="cancel" />
    </Modal>

  </div>
</template>

<script>
import Tables from "_c/tables/table-only.vue";
import Forms_stand_user from "./add_stand_user_form.vue";

import { getStandUser, deleteStandUser, getLiveType, addStandUser, getStrategyUser, editStandUser, getClassifys} from "@/api/data";
export default {
  name: "finance",
  components: {
    Tables,
    Forms_stand_user
  },
  data() {
    return {
      page: 1,
      total: 0,
      pageSize: 10,
      letterDetailFlag: false,
      tableLoading: true,
      allMoney: 0.0,
      classify_id:'',
      startTime: "",
      endTime: "",
      details:[],
      dy_id:'',
      id:'',
      liveIds:[],
      userIds:[],
      user_id:'',
      live_id:'',
      keyword:'',
      resetFlag: false,
      showEditStandUserModal:false,
      showAddStandUserModal:false,
      columns: [
        {type: 'index', title: '序号',width: 100, align: "center"},
        { title: "分类" , key: "classify", editable: true, align: "center"},
        { title: "用户名" , key: "username", editable: true, align: "center"},
        { title: "平台" , key: "live", editable: true, align: "center"},
        { title: "立即确认" , key: "push",  editable: true,
        render: (h, params) => {
          let text = params.row.push?"是":"否"
            return h('span', text)
          }}, 
        { title: "主页链接" , key: "home_url",  editable: true,
        render: (h, params) => {
            return params.row.home_url != '' ? h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.download(params.row.home_url);
                    },
                  },
                },
                "查看"
              )
            ]) : h('span', '');
          }}, 
       { title: "创建时间" , key: "create_time", editable: true, align: "center"},      
       {
          title: "Handle",
          key: "handle",
          render: (h, params) => {
            return h("div", [
            h(
                "Button",
                {
                  props: {
                    type: "info",
                    size: "small",
                  },
                  on: {
                    click: () => {
                      this.showEditUser(params);
                    },
                  },
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small",
                  },
                  on: {
                    click: () => {
                      this.handleDelete(params);
                    },
                  },
                },
                "删除"
              )
            ]);
          },align: "center"
        }
      ],
      tableData: [],
    };
  },
  methods: {
    download(url) {
      window.open(url, '_blank');
    },
    backHistory() {
      this.$router.go(-1);
    },
    handleButtonSearch(){
      this.page = 1
      this.handleSearch()
    },
    showAddUser() {
      this.showAddStandUserModal = true;
      this.resetFlag = !this.resetFlag;

      getClassifys().then((res) => {
        var classifyIds = res.data.data.records;
        this.$refs.addStandUser.setClassifyData(classifyIds);
      });

      getLiveType().then((res) => {
        var liveTypes = res.data.data;
        this.$refs.addStandUser.setLiveType(liveTypes);
      });
      
      getStrategyUser({}).then((res) => {
        var users = res.data.data.records;
        this.$refs.addStandUser.setUsers(users);
      });

    },showEditUser(params) {
      this.showEditStandUserModal = true;

      getClassifys().then((res) => {
        var classifyIds = res.data.data.records;
        this.$refs.editStandUser.setClassifyData(classifyIds);
      });

      getLiveType().then((res) => {
        var liveTypes = res.data.data;
        this.$refs.editStandUser.setLiveType(liveTypes);
      });
      
      getStrategyUser({}).then((res) => {
        var users = res.data.data.records;
        this.$refs.editStandUser.setUsers(users);
      });
      
      this.$refs.editStandUser.setEditData(params.row);

    },editStandUserEmit(formValidate){
      let data = {
        url:formValidate.home_url,
        username:formValidate.username,
        live_id:formValidate.live_id,
        id:formValidate.id,
        ids: formValidate.users,
        classify_id: formValidate.classify_id,
        push: formValidate.push == '是'
      }
      editStandUser(data)
        .then((res) => {
          if (res.data.code == 200) {
            this.showEditStandUserModal = false
            this.$Message.success("成功!");
            this.handleSearch();
          } else {
            this.$Message.error(res.data.msg);
          }
        })
        .catch((err) => {
          this.$Message.error("失败!");
        });

    },
    addStandUserEmit(formValidate){
      let data = {
        url:formValidate.home_url,
        username:formValidate.username,
        live_id:formValidate.live_id,
        ids: formValidate.users,
        classify_id: formValidate.classify_id,
        push: formValidate.push == '是'
      }
      addStandUser(data)
        .then((res) => {
          if (res.data.code == 200) {
            this.showAddStandUserModal = false
            this.$Message.success("成功!");
            this.handleSearch();
          } else {
            this.$Message.error(res.data.msg);
          }
        })
        .catch((err) => {
          this.$Message.error("失败!");
        });

    },
    handleDelete(params) {
        this.$Modal.confirm({
            title: '提示',
            content: '<p>是否确认删除？</p>',
            onOk: () => {
              deleteStandUser(params.row.id)
                .then((res) => {
                    if (res.data.code == 200) {
                        this.tableData.splice(params.index, 1);
                        this.$Message.success("成功!");
                    } else {
                        this.$Message.error(res.data.msg);
                    }
                }).catch((err) => {
                    this.$Message.error("失败!");
                });
            },
            onCancel: () => {
                this.$Message.info('已取消');
            }
        });
    },
    cancel() {},
    changePage(page) {
      this.page = page;
      this.handleSearch();
    },
    changePageSize(pageSize) {
      this.pageSize = pageSize;
      this.handleSearch();
    },
    handleSearch() {
      this.setTableLoading(true);
      let params = {
        page: this.page,
        pageSize: this.pageSize,
        keyword: this.keyword,
        live_id: this.live_id,
        user_id: this.user_id
      };
      getStandUser(params).then((res) => {
        if (res.data.code == 200) {
          this.tableData = res.data.data.records;
          this.total = res.data.data.total;
        } else {
          this.tableData = [];
          this.total = 0;
        }
        this.setTableLoading(false);
      });
    },
    setTableLoading(state) {
      this.tableLoading = state;
    }
  },
  mounted() {
    this.handleSearch()
    getLiveType({}).then((res) => {
      if (res.data.code == 200) {
        var lives = res.data.data;
        var data = new Array()
        for (var i = 0; i < lives.length; i++) {
          data[i] = { id: lives[i].id.toString(), name: lives[i].name }
        }
        this.liveIds = data
      }
    });
    getStrategyUser({}).then((res) => {
      var users = res.data.data.records;
      var data = new Array()
      for (var i = 0; i < users.length; i++) {
        var user = users[i]
        data.push({ id: user.id.toString(), name: user.username })
      }
      this.userIds = data
    });
  },
};
</script>
